import React from "react";
import { connect } from "react-redux";
import {
  getBankDetailsStatus,
  verifyIFSCCodeDetails,
  toggleModalAction
} from "../redux/actions/userAction";
import PropTypes from "prop-types";
import bankAcnt from "../assets/bankAcnt.png";
import navarrow from "../assets/back_btn.png";
import Timer from "../Redeem/OTPTimer";
import VerificationAlert from "../models/VerificationAlert";
import { Link } from "react-router-dom"
import { ADD_BANK_PAGE_STRINGS } from '../Strings';
import { WebToNativeMessage } from "../Common/Utils";

class AddBankAccount extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      account_number: "",
      account_name: "",
      reaccount_number: "",
      ifsc: "",
      errors: {
        message: "",
        errorMsgforIfSC: ""
      },
      //token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJjbTBnY3U3cGczcDFkdDMiLCJ1c2VybmFtZSI6IjF3QThLd2dKIiwicm9sZXMiOiJ1c2VyIiwic3RhdHVzIjp0cnVlLCJkZXZpY2VfaWQiOiJjYjJmNzg4OTliOWMwZTNjIiwiaWF0IjoxNjI4NjY4MzA4LCJleHAiOjE2Mjg3NTQ3MDh9.1v2vKGQQcGKcy3rKZLcf7oJQzOd8IFHhsekpEZd7Cdg",
      bankName: "",
      address: "",
      accountNumber: "",

      isVerifybuttonEnable: false,
      isShowTimer: false,
      email: "",
      mobile: "",
      bankStatus: "",
      ifscVerify: false,
      isAllfieldsEnter: false,
      isbankStatus: false,
      verifybtntext: "Verify",
      verifyIFSC: false,
      token: window.sessionStorage["token"],
      channel: window.sessionStorage["channel"],
      actnumberregexp: /^[0-9\b]+$/,
      isSuccessMsg: false,
      duplicatedata: "",
      deleteddata: "",
      bankList: [],
      isIFSCVerified: false,
      //stateName:"",
      accountNumbersEnabled: true
      //token:"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiIzb2lxYng3eWx2N3d4bm8iLCJzY3JlZW5OYW1lIjoiaGVsbG8yMDMiLCJzdGF0dXMiOnRydWUsImRldmljZV9pZCI6Ijg1NTVjNTM4MWIzOTUwMzMiLCJpYXQiOjE2Mjg3NTg3OTcsImV4cCI6MTYyODg0NTE5N30.ANnaYLma2bxdL60SDgP_eW7iMEAQQKb0t8nWQ5kIh3A"
    };
  }


  componentWillMount() {
    console.log("Life Cycle Method Component willMount Called");
    this.setState({ token: window.sessionStorage["token"] })
    this.setState({ channel: window.sessionStorage["channel"] })
    //Apxor Event changes added
    //10557 Issue Fix
    WebToNativeMessage({ type: "redeemCTEvent", eventName: "PF_AddBankAccountLoad", eventProperties: {} })
    //10557 issue Fix
    //Apxor Event Changes end
  }
  componentDidMount() {
    console.log("Life Cycle Method Component DidMount Called", this.props);
    if (this.props.location.data !== undefined && this.props.location.data.duplicatedata !== undefined && this.props.location.data.account_number !== undefined && this.props.location.data.reaccount_number !== undefined && this.props.location.data.ifsc !== undefined) {
      this.setState({
        duplicatedata: this.props.location.data.duplicatedata,
        account_number: this.props.location.data.account_number,
        reaccount_number: this.props.location.data.reaccount_number,
        ifsc: this.props.location.data.ifsc
      })
    }
    // //Apxor Event changes added
    // WebToNativeMessage({type:"redeemCTEvent",eventName:"PF_AddBankAccountLoad,",eventProperties:{}})
    // //Apxor Event Changes end
  }
  componentDidUpdate() {
    console.log("Life Cycle Method Component DidUpdate Called");
  }

  // onKeyUp=evt=>{
  //   console.log("input event keydowncode:"+evt.keyCode+"..."+evt.key+"..."+evt.charCode)
  //   this.handleBackSpace("onkeydown",evt)
  // }

  // handleBackSpace(from,evt){
  //   if(from === "onchange"){
  //     this.setState({deleteddata:evt.target.value})
  //   }
  //   console.log("from in handleBackSpace::"+from+"...event"+evt+"..."+evt.target.value+"...deleteddata"+this.state.deleteddata+"..."+this.state.account_number.length+"..."+this.state.duplicatedata.length)
  //   if(from === "onkeydown"){
  //     let userAgent = window.navigator.userAgent.toLocaleLowerCase();
  //       console.log("useragent string::",userAgent.toString())
  //       if (userAgent.toString().includes("wv")){
  //         if(evt.key === "Backspace"){
  //         if(evt.keyCode === 229 || evt.keyCode === 8){
  //           if(this.state.account_number.length !== this.state.duplicatedata.length-1){
  //             var x=this.state.duplicatedata.substring(0,this.state.account_number.length-1)
  //             console.log("value of x in handlebackspace:"+x)
  //             this.setState({duplicatedata:x})
  //          }
  //           this.setState({account_number : this.state.deleteddata});
  //         }
  //       }
  //       }else{
  //         if(evt.keyCode === 8 || evt.key === "Backspace"){
  //           if(this.state.account_number.length !== this.state.duplicatedata.length-1){
  //             var x=this.state.duplicatedata.substring(0,this.state.account_number.length-1)
  //             console.log("value of x in handlebackspace:"+x)
  //             this.setState({duplicatedata:x})
  //          }
  //           this.setState({account_number : this.state.deleteddata});
  //         }
  //       }

  //   }
  // }

  onChange = evt => {
    this.setState({ errors: { message: "" }, isAllfieldsEnter: false, verifybtntext: "Verify" });
    console.log("VERIFY IFSC::::", this, this.state.verifyIFSC, this.state.ifsc.length, evt.target.name, evt.target.value, evt.target.value.length)
    //Issue fix
    if (evt.target.name === "ifsc" && evt.target.value.length < 12) {
      //this.setState({ [name] : value });
      evt.target.value = evt.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
      this.setState({ [evt.target.name]: evt.target.value });
      console.log("VERIFY IFSC::::IN", evt.target.value.length)

      if (evt.target.value.length > 10) {
        console.log("Verify IFSC Code Calling if Length", this.state.verifyIFSC, evt.target.value.length, this.state.ifsc);
        this.setState({ isAllfieldsEnter: false, verifyIFSC: true });
        this.verifyIfscCode(evt, evt.target.value);
      } else {
        console.log("Verify IFSC Code Calling else length", this.state.verifyIFSC, evt.target.value.length);
        this.setState({ isAllfieldsEnter: false, verifyIFSC: false });
      }

    }
    else if (evt.target.name === "account_number") {
      const { name, value } = evt.target
      console.log("checkfor regular expression:", new RegExp(/^[0-9\b]+$/).test(value) + "...value ", value)
      if (new RegExp(/^[0-9\b]+$/).test(value) || value === "") {
        this.setState({ [name]: value });
      }
      //   if(value.search(/\d/)!==-1){

      //     for(var i=0;i<value.length;i++){
      //       var str=value.substring(value.length-1,value.length)
      //       var x=this.state.duplicatedata+str
      //       console.log("value in loop",str+"...duplicatedata",this.state.duplicatedata+"...x"+x)
      //       this.setState({duplicatedata:x})

      //     }
      //     var dummyText = Array(value.length).fill('*').join("");
      //     console.log("text:::",dummyText)
      //     this.setState({ [name] : dummyText });

      //   }else{
      //   this.handleBackSpace("onchange",evt)
      //   }
    }
    else if (evt.target.name === "reaccount_number") {
      evt.target.value = evt.target.value.replace(/[^0-9 ]+/g, '') // fix for PL-3616

      var val = evt.target.value;
      const valArray = val.split(' ').join('').split('');
      var valSpace = val.split("")

      // to work with backspace
      if (valSpace[valSpace.length - 1] == ' ') {
        var valSpaceN = valSpace.slice(0, -2)
        val = valSpaceN.join("")
        this.setState({ [evt.target.name]: val });
        return;
      }

      if (isNaN(valArray.join('')))
        return;
      if (valArray.length % 4 === 0 && valArray.length > 0) {
        this.setState({ [evt.target.name]: val + "  " });
      } else {

        this.setState({ [evt.target.name]: val })
      }

      //this.setState({ [evt.target.name]: evt.target.value });
      console.log("Events" + evt.target.name, evt.target.value + "...valarray length" + valArray.length);


    }


    console.log("AccountNumberlength", this.state.account_number.length, this.state.reaccount_number.length, this.state.verifyIFSC.length > 0)
    if (this.state.account_number.length > 0 && this.state.reaccount_number.length > 0 && this.state.ifsc.length > 0) {
      console.log("AccountNumberlength if", this.state.account_number.length)
      this.setState({ isAllfieldsEnter: true });
    } else {
      this.setState({ isAllfieldsEnter: false })
    }


  };

  //"approved", "processing", "rejected"
  handleLinkBankResponse = (status) => {
    console.log("handle link bank response :::::", status);
    sessionStorage.setItem('response', JSON.stringify(status));
    if (status === "rejected") {
      console.log("handle link bank response :::::", status);
      this.props.toggleModalAction(
        true,
        <VerificationAlert
          header={ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFICATION_TITLE}
          body={ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFICATION_BODY}
          btntext={ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFICATION_OKAY}
        ></VerificationAlert>
      );
    } else {
      //this.handlebackbtn();
      console.log("handle link bank response else :::::", status);
      this.props.location.data.handleBackBtnClick(status)
      this.props.history.push("/redeem/")
    }
  };

  handlebackbtn = () => {
    this.props.history.push("/redeem/")
  }

  handleTimerEnd = () => {
    console.log("TimerEnd Case")
    sessionStorage.setItem('response', JSON.stringify("timerend"));
    this.handleLinkBankResponse("timerend");
  };

  showPanMissMatchPopup = (statusCode, msg) => {
    if (statusCode == "3140") {
      this.props.toggleModalAction(
        true,
        <VerificationAlert
          header={ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFICATION_TITLE}
          body={msg}
          btntext={ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFICATION_OKAY}
        ></VerificationAlert>
      );
    } else {

    }
  }

  //For IFSC Code verification
  verifyIfscCode = async (evt, ifscValue) => {
    try {
      console.log("Verify IFSC Method", this.state.ifsc + "...ifscValue" + ifscValue);
      if (ifscValue === "" || ifscValue.length < 3) {
        this.setState({ errors: { message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_11_DIGITS_IFSC } });
      } else {
        await this.props.verifyIFSCCodeDetails(
          this.state.token,
          ifscValue
        );
        const { ifscDetails } = this.props.userState;
        if (ifscDetails.error) {
          console.log("React", ifscDetails.error);
          await this.setState({
            errors: { message: ifscDetails.error },
            ifscVerify: false,
            isSuccessMsg: true
          });
        } else if (
          ifscDetails.message === ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_SUCCESS_MSG
        ) {
          console.log(
            "React",
            ifscDetails.message,
            ifscDetails.data.BANK,
            ifscDetails.data.ADDRESS,
            ifscDetails.data.STATE

          );
          await this.setState({
            errors: { message: ifscDetails.message },
            bankName: ifscDetails.data.BANK,
            address: ifscDetails.data.ADDRESS,
            ifscVerify: true,
            isSuccessMsg: true,
            //stateName:ifscDetails.data.STATE,
            isIFSCVerified: true
          });
          if (this.state.account_number.length > 0 && this.state.reaccount_number.length > 0) {
            this.setState({ accountNumbersEnabled: false, isAllfieldsEnter: true })
          }
        } else {
          await this.setState({
            errors: { message: ifscDetails.message },
            ifscVerify: false,
            isAllfieldsEnter: false,
            isSuccessMsg: false,
            isIFSCVerified: false,
            accountNumbersEnabled: true
          });
        }
      }

      evt.preventDefault();
    } catch (err) {
      console.error(err);
    }
  };

  componentWillUnmount() {

  }

  //For Submitting Bank details
  submitBankDetails = async evt => {
    try {
      var datareaccount_number = this.state.reaccount_number.replace(/ /g, '')
      console.log("account number in submitBankDetails", this.state.account_number + "...." + this.state.reaccount_number + "...datareaccount_number" + datareaccount_number + "length" + datareaccount_number.length)
      if (
        this.state.account_number === "" ||
        this.state.account_number.length < 3
      ) {
        console.log("Enter Valid Account Number");
        this.setState({ errors: { message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ENTER_ACC_NUMBER } });
        this.setState({ isAllfieldsEnter: false, isSuccessMsg: false });
        return false;
      } else if (
        datareaccount_number === "" ||
        datareaccount_number.length < 3
      ) {
        console.log("Enter Valid re Account Number");
        this.setState({
          errors: { message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ENTER_RE_ACC_NUMBER },
          isAllfieldsEnter: false, isSuccessMsg: false

        });

        return false;
      } else if (
        this.state.ifsc.length < 11
      ) {
        console.log("Enter Valid IFSCCode");
        this.setState({
          errors: { message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_11_DIGITS_IFSC },
          isAllfieldsEnter: false, isSuccessMsg: false
        });
        return false;
      } else if (this.state.ifsc.length > 0 && !this.state.isIFSCVerified
      ) {
        console.log("Please Verify IFSC Code");
        this.setState({
          errors: { message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_PLEASE_VERIFY_IFSC },
          isAllfieldsEnter: false, isSuccessMsg: false
        });
        return false;
      } else if (
        !(this.state.account_number === datareaccount_number) &&
        (this.state.account_number != null &&
          datareaccount_number != null)
      ) {
        this.setState({
          errors: {
            message: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ACC_NUMBER_NOT_MATCH_RE_ENTER,
          },
          isAllfieldsEnter: false,
          isSuccessMsg: false,
          accountNumbersEnabled: true
        });
        return false;
      } else {
        this.setState({ isShowTimer: true, verifybtntext: "Verifying", isAllfieldsEnter: false });
        await this.props.getBankDetailsStatus(
          this.state.token,
          this.state.account_number,
          this.state.account_name,
          this.state.ifsc
        );
        const { bankDetails } = this.props.userState;
        console.log("Bank details::::", bankDetails);
        if (bankDetails.error) {
          console.log("Bank details error::::", bankDetails.error);
          await this.setState({
            errors: { message: bankDetails.error.message },
            isbankStatus: true,
            isShowTimer: false,
            isAllfieldsEnter: false,
            verifybtntext: ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFY_BUTTON_TEXT,
            isSuccessMsg: false,
            accountNumbersEnabled: true

          });
          //PL-1677 Issue Fix Start
          this.showPanMissMatchPopup(bankDetails.error.statusCode, bankDetails.error.message);
          //PL-1677 Issue Fix End
        } else {
          console.log("React", "else case", this.state.account_number);
          await this.setState({
            errors: { message: bankDetails.message },
            bankStatus: bankDetails.bankStatus,
            isbankStatus: true,
            isSuccessMsg: false,
            isShowTimer: false,
            accountNumbersEnabled: true,
            bankList: bankDetails.bankList
          });
          console.log("bankList", this.state.bankList, this.state.account_number);

          console.log("Method Called", this.state.bankList)
          if (bankDetails.bankList !== undefined) {
            const bankobj = bankDetails.bankList.find(
              x => x.accountNumber == this.state.account_number
            );
            console.log("bank object loop", bankobj);
            this.setState({ bankStatus: bankobj.bankStatus })
            console.log("Bank Statues::::::", bankobj.bankStatus)
            this.handleLinkBankResponse(bankobj.bankStatus);
          }

          if (bankDetails.statusCode && bankDetails.error !== undefined) {
            //PL-1677 Issue Fix Start
            this.showPanMissMatchPopup(bankDetails.error.statusCode, bankDetails.error.message);
            //PL-1677 Issue Fix end
          }
        }
      }
      evt.preventDefault();
    } catch (err) {
      console.error(err);
    }
  };

  openIFSCComponent = () => {
    this.props.history.push({ pathname: '/ifscpage/', data: { handleBackBtnClick: this.props.location.data.handleBackBtnClick, duplicatedata: this.state.duplicatedata, account_number: this.state.account_number, reaccount_number: this.state.reaccount_number, ifsc: this.state.ifsc } })
  }


  render() {
    //console.log("dummytext in onrender()",window.dummyText+"..."+this.state.accountnumbertv)
    console.log("app src", window.sessionStorage["src"])
    return (
      <div className="w-100 bg-white" style={{ minHeight: '100vh' }}>
        {this.state.channel == "PKAPS" || this.state.channel == "PKIPS" || window.sessionStorage["channel"] == "PKAPS" || window.sessionStorage["channel"] == "PKIPS" ?
          <nav
            className="ph2 pv2 tr sticky top-0 left-0 right-0 shadow-4 z-999 "
            style={{ backgroundColor: "#eabf69", color: "#032146" }}
          >
            <div className="w-100 db center">
              <div className=" flex justify-start items-center">
                <img
                  fill="#ffffff"
                  className="w1"
                  src={navarrow}
                  id="addBankAcnt_backBtn"
                  alt="no available" style={{ width: "20px" }}
                  onClick={() => this.handlebackbtn()}
                />
                <span>
                  <p className="f4-l f4 tc text-medium mv0 ml2 ">Redeem </p>
                </span>
              </div>
              <div className="tc"></div>
              <div className="dark-gray fw5 link dim f8 tracked-tight w-20 flex justify-end items-center"></div>
            </div>
          </nav>
          :
          <nav className='navbar'>
            <div className="nav-container" >
              <img
                className='backBtn'
                id="addBankAcnt_backBtn"
                src={navarrow}
                style={{ width: "40px" }}
                onClick={() => this.handlebackbtn()}
              />
              <p className="nav-text" style={{ textAlign: 'center' }}>Redeem</p>
              <div></div>
            </div>
          </nav>
        }

        <div className="ph2 ph6-l  f6 f4-l f5-ns  center bg-white">
          <div className="w-100 fw6 b f6 f4-l f5-ns db  tl">
            <p>Link Bank Account</p>
          </div>
          <form onSubmit={e => { e.preventDefault(); }} autoComplete="off">
            <div
              className="center br2 ba pa1 pa2-l mb2 b--black-10 flex flex-column"
              style={{
                backgroundColor: "#fffdec",
                color: "#0a2144",
                paddingTop: "1rem",
                paddingBottom: "0.5rem"
                //UAT changes
                //height:"175px"
              }}
            >
              <div className="mt1 uxcam-occlude">
                <input
                  id="account_number"
                  type="password"
                  className={window.sessionStorage["src"] === "android" ? "w-100 fw6 pa1 f6 f4-l f5-ns black bl-0 bt-0 br-0 bb bg-transparent mv1 outline-0" : "w-100  fw6 pa1 f6 f4-l f5-ns black bl-0 bt-0 br-0 bb bg-transparent mv1"}
                  placeholder="Account Number"
                  name="account_number"
                  maxLength="20"
                  value={this.state.account_number}
                  onChange={e => this.onChange(e)}
                  readOnly={!this.state.accountNumbersEnabled}
                  style={{ color: '#032146' }}
                  autoComplete="off"
                ></input>
              </div>


              <div className="mt1 uxcam-occlude">
                <input
                  id="reaccount_number"
                  type="tel"
                  className={window.sessionStorage["src"] === "android" ? "w-100 fw7 pa1 f6 f4-l f5-ns black bl-0 bt-0 br-0 bb bg-transparent mv1 outline-0" : "w-100 fw7 pa1 f6 f4-l f5-ns black bl-0 bt-0 br-0 bb bg-transparent mv1"}
                  placeholder="Re-enter Account Number"
                  name="reaccount_number"
                  pattern="\d*"
                  onKeyDown={e => (e.keyCode === 32) && e.preventDefault()}
                  value={this.state.reaccount_number}
                  onChange={e => this.onChange(e)}
                  maxLength="28"
                  readOnly={!this.state.accountNumbersEnabled}
                  style={{ color: '#032146' }}
                  autoComplete="off"
                ></input>
              </div>

              <div className="mt1"></div>
              <div className=" w-100 flex justify-between items-center bb b--gray uxcam-occlude  ">
                <input
                  id="ifsc"
                  type="text"
                  className=" w-60 placeholder fw7 pa1 f6 f4-l f5-ns black bl-0 bt-0 br-0 bb-0 bg-transparent mv1 outline-0"
                  placeholder="IFSC Code"
                  name="ifsc"
                  maxLength="11"
                  value={this.state.ifsc.toUpperCase()}
                  onChange={e => this.onChange(e)}
                  autoComplete="off"
                ></input>

                {this.state.verifyIFSC ? (
                  <div
                    className=" tr  f6 f4-l f5-ns underline  blue "
                  //onClick={(e)=>this.verifyIfscCode(e,this.state.ifsc)}
                  >

                  </div>
                ) : (

                  <span id="addBankAcnt_findCode" className="tr f6 f4-l f5-ns  dim underline blue" onClick={() => this.openIFSCComponent()}>Find Code</span>

                )}
              </div>
              <div className="w-100 ">
                {this.state.isSuccessMsg ? (
                  <div className="f6 mt1 tl f6 f4-l f5-ns text-bold green" id="error-msg">
                    {this.state.errors.message}
                  </div>
                ) : (<div className="f6 mt1 tl f6 f4-l f5-ns text-bold red " id="error-msg">
                  {this.state.errors.message}
                </div>)}

              </div>
            </div>
          </form>
          {this.state.ifscVerify && (
            <div>
              <div
                className="w-100 fw6 f6 f4-l f5-ns db tl"
                style={{ paddingTop: "0.5rem", color: "#032146" }}
              >
                <p>{ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_VERIFY_ACC_TEXT}</p>
              </div>


              <div
                className="w-100 br2 pa1 db ba b--black-20 bg-near-white flex flex-column"
                style={{ color: "#0a2144" }}
              >
                <div className="flex items-center pr1 ph0-l">
                  <img
                    className="br-100 "
                    style={{ width: "1.4rem" }}
                    src={bankAcnt}
                    alt="no"
                  />
                  <span className="ml2 f6 f4-l f5-ns fw6 db black-70">
                    {this.state.bankName}
                  </span>
                </div>
                <div className="flex flex-column " style={{ marginLeft: "1.4rem" }}>
                  <span className="ml2 pr1 f6 f4-l f5-ns black-70">
                    {this.state.account_number}
                  </span>
                  <text className="ml2 pr1 f6 f4-l f5-ns black-70" style={{ wordWrap: "break-word" }}>{this.state.address}</text>
                </div>
              </div>
            </div>
          )}

          <div>
            {/* <div className="f6 f5-l fw7 ">{ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_NOTE}</div> */}
            <ul className="list pl0">
              <li className="f6 f5-l fw7">{ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_NOTE}</li>
              {window.sessionStorage["channel"] == "GAPS" || window.sessionStorage["channel"] == "GFPS" ? (<li className="f7 f6-l fw5 " style={{ color: "#032146" }}> {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONLY_ACCEPT_SAME_PAN_NAME_NOTE_GAPS}</li>) : (<li className="f7 f6-l fw5 " style={{ color: "#032146" }}> {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONLY_ACCEPT_SAME_PAN_NAME_NOTE}</li>)}
              <li className="f7 f6-l fw5 " style={{ color: "#032146" }}> {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_WILL_SEND_ONE_RUPEE_TO_ACC}</li>
            </ul>
            {/* <p className="f7 f6-l fw5 " style={{color:"#032146"}}>
             {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONLY_ACCEPT_SAME_PAN_NAME_NOTE}
              </p>
              <p className="f7 f6-l fw5 " style={{color:"#032146"}}>
             {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_WILL_SEND_ONE_RUPEE_TO_ACC}
              </p> */}
          </div>
        </div>
        <div className="w-100 fixed bottom-0 mb1 mb4-l tc f7 flex flex-column center bg-white ">
          <div className="f7 f4-l f5-ns  mt1  ph2 ph5-l " style={{ color: "#959595", fontWeight: 'normal' }}>
            {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONCE_VERIFY_WILL_ADD_IT_TO_A23}
          </div>
          {this.state.isAllfieldsEnter ? (
            <button
              id="addBankAcnt_verifyBtn"
              className="w-40 mt2 f6 ba br2 mb2 tc ph5 pv2 white  btn-green btn-green-login center "
              onClick={this.submitBankDetails}
            >
              {this.state.verifybtntext}
            </button>
          ) : (
            <button
              id="addBankAcnt_verifyBtn"
              className="f5 ba fw6 mt2 mb1 mb4-l br2 w-40 disable-btn tc ph3 pv2 white dib  center "
              // style={{ borderColor: "#959595", color: "#959595"}}
              style={{ color: "#03214633" }}
            >
              {this.state.verifybtntext}
            </button>
          )}

          {this.state.isShowTimer ? (
            <div className="mb1 mb4-l ">
              <Timer handleTimerEnd={() => this.handleTimerEnd()} ></Timer>
              <div className="mb1 mb4-l">
              </div>
            </div>

          ) : (<div></div>)
            //Done changes as per PL1.4 UI/UX Changes start
            //(<div>
            // {this.state.isAllfieldsEnter?( <div className="f8 f4-l f4-ns mt1 ph4 ph6-l mb2 mb4 mt2" style={{color:"#032146",fontWeight:'bold'}}>
            // {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONCE_VERIFY_WILL_ADD_IT_TO_A23}
            // </div>):( <div className="f8 f4-l f4-ns mt1 ph4 ph6-l mb2 mb4 mt2" style={{color:"#959595",fontWeight:'bold'}}>
            //               {ADD_BANK_PAGE_STRINGS.KEY_ADD_BANK_ONCE_VERIFY_WILL_ADD_IT_TO_A23}
            //             </div>)}

            //           </div>


            //)}
          }
        </div>
      </div>
    );
  }
}
AddBankAccount.propTypes = {
  userState: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  userState: state.userState
});
export default connect(
  mapStateToProps,
  { getBankDetailsStatus, verifyIFSCCodeDetails, toggleModalAction }
)(AddBankAccount);
